export default {
    en:{
        about: "About",
        services: "Services",
        menu: "Menu",
        choose: "Choose",
        order: "Order",
        follow: "Follow",
        fresh: "Fresh Products",
        environment: "Environmentally Friendly",
        delivery: "Home Delivery",
        phone : "Cell phone",
        namesurname : "Name",
        recoverpw : "Forgot my password",
        recovertitle: "Recover password",
        recover : "Recover",
        repeatpw: "Repeat password",
        newpw : "New password",
        code: "Code",
        termstxt : "I've read and accept the ",
        termstxt2: ' and the ',
        policy: 'Privacy Policy',
        register : "Register",
        registration : "Register",
        haveaccount : "I already have an account.",
        gologin: 'Go to Log in',
        confirm : "Confirm",
        sms : "You will receive a sms with a code to recover your account",
        smsconfirm : "We've sent a code to the phone number",
        enter : "Log in",
        address : "Address",
        name : "Name",
        zipcode : "Zip code",
        city: 'City',
        surname : "Surname",
        zone : "Zone",
        message : "Message",
        servicemessage: "Message (include all relevant details, such as date, nº of people, etc",
        door : "Door",
        floor : "Floor",
        nif : "VAT",
        noorders : "You do not have ongoing orders.",
        profile : "Profile",
        updated : "Updated!",
        hi : "Hello",
        hdtext : "Isert your zip code and check if it's in our delivery area.",
        tatext: "Choose the store where you want to pick up your order.",
        status : "Order status",
        tracker0 : "Order payed",
        tracker1 : "Order on hold",
        tracker2 : "Order in preparation",
        tracker3 : "Quality control",
        tracker31 : "Order ready",
        tracker4 : "Order on course",
        tracker5 : "Order delivered",
        personalData : "Personal Data",
        billingData : "Billing Data",
        deliveryaddr: "Delivery Addresses",
        billingaddr : "Billing Address",
        noorder : "You do not have information to see the order status",
        feels : "Sinta-se em casa",
        cart : "Shopping cart",
        cartempty : "Your cart is empty",
        add : "Add",
        interested: "Interessado em",
        agendar : "Agendar um serviço?",
        workwith : "Work with us",
        kitchen : "Kitchen",
        client : "Callcenter",
        client1 : "Callcenter",
        distribution : "Distribution",
        kitchendesc : "Looking for talented sushimen",
        clientdesc : "We look for anyone with a smile in the voice",
        distributiondesc : "We are looking for the friendliest couriers in Portugal",
        send : "Send",
        privacy : "Privacy Policy",
        terms : "Terms and Conditions",
        feedback : "Give us feedback",
        seeall: "See all",
        apply: "Apply",
        finalize: "Finalize order",
        validcode: "Valid code!",
        invalidcode: "Invalid code!",
        menus: "Menus",
        personalize: "Personalize",
        options: "Options",
        verify: "Verify",
        nodelivery: "We are very sorry! Home Sweet Sushi still does not deliver on the indicated zipcode. Do you want to ",
        nodelivery1: "? For further information please contact us on the number 211625990",
        closedstore: "At the moment the store that serves this zipcode is under maintenance. We promisse to be brief.",
        wrongformat: "Wrong format xxxx-xxx",
        product: "Product",
        quantity: "Quantity",
        price: "Price",
        continue: "Continue",
        remove: "remove",
        prodstotal: "Products total:",
        taxtext: "Estimated delivery fee:",
        iva: "*VAT included",
        selectstore: "Select the store",
        when: "When do you want your order to be delivered?",
        today: "Today",
        tomorrow: "Tomorrow",
        selectschedule: "Choose the time",
        totalprice: "Total price",
        back: "Back",
        payment: "How do you want to pay?",
        dinheiro: "Money",
        MB: "ATM",
        mbway: "MB Way",
        cc: "Credit.C",
        finalize1: "Finalize order",
        maxmoney: "Our couriers do not have change for bills over 20€",
        change: "How much change will you need?",
        cardnumber : "Card number",
        cardholder : "Card holder",
        orderdone: "Order submitted",
        orderdonetxt: "Your order was successfully placed. Track your order now",
        hiText: "Welcome",
        category: "Categories",
        spec: "Characteristics",
        all: "All",
        carddetails: "Insert your card details",
        ordersuccessmbway: "Your order will be processed as soon as you accept the payment in the MB WAY app",
        error: "Error!",
        history: "Order History",
        nohistory: "You have no past orders",
        singOrder: "Order",
        repeat: "Repeat Order",
        added: "Added to Cart!",
        minorder: "For a delivery order without atleast one menu, the minimum is 16€",
        error601: 'The Credit Card was not accepted',
        error602: 'CVV or Brand invalid',
        error603: 'The Credit Card does not have the 3D secure activated',
        alternativephone: 'Alternative contact',
        contact: 'Contact',
        people: 'How many people?',
        quantityerror: 'Choose atleast ',
        quantityerror1: ' on the ',
        quantityerror2: 'º step',
        desire: 'Do you want to add a desert?',
        mbwaypromo: 'The promocode #campanhambway will only be applied if you choose the MB Way payment method',
        birthday: 'Birthday (dd/mm/yyyy)',
        birthdayformat: 'Birthday format id invalid. Use dd/mm/yyyy',
        insertlogin: 'Insert your data to continue',
        registese: 'Register',
        welcome: 'Welcome',
        noaccount: "Doesn't have an account?",
        createaccount: 'Create an account',
        wrongnum: 'The number is incorrect?',
        goback: 'Go back',
        total: 'Total',
        tax : 'Delivery tax',
        mydata: 'My data',
        activeorders: 'Active orders',
        orderhistory: 'Order history',
        companyname: 'Company name',
        number : 'Number',
        companytype: 'Type of Establishment',
        restaurant: 'Restaurant',
        bar: 'Coffee-Bar',
        hotel: 'Hotel',
        other: 'Other',
        other1: 'Delivery3',
        save: 'Save',
        account: 'Account',
        home: 'Home',
        home1: 'Delivery1',
        work: 'Work',
        work1: 'Delivery2',
        makelog: 'Login',
        yourprofile: 'Your profile',
        yourreq: 'Your order',
        deliverydetails: 'Delivery Details',
        deliverydate: 'Delivery Date',
        info1: 'Orders',
        info2: 'before 17h00',
        info3: 'will be processed on the same day and delivered on the next one',
        info4: 'after 17h00',
        info5: 'will be processed on the next day',
        info6: 'Orders processed',
        info7: 'at friday',
        info8: 'have an aditional cost of 5€',
        selectday: 'Select the delivery day',
        selecthour: 'Select the delivery hour',
        selectoneday: 'Select a day',
        selectonehour: 'Select a schedule',
        obs: 'Observations',
        promocode: 'Promo code',
        putpromo: 'Insert a promo code',
        paymentmethod: 'Payment method',
        changefor: 'Change for',
        mbwayphone: 'Phone number associated',
        offers: 'Offers',
        deltax: 'Delivery Tax',
        tdisc: 'Total with discount',
        mintotal: 'The total minimum is 5€',
        cart1: 'Cart',
        start: 'Home',
        aboutus: 'About us',
        blog: 'Blog',
        faq: 'FAQ',
        contacts: 'Contacts',
        reseller: "I'm a reseller",
        store: 'Store',
        scheduletxt: 'The deliveries are processed',
        scheduletxt1: 'between',
        scheduletxt2: 'of the selected day',
        moreprods: 'Do you want to add more produtcs?',
        backstore: 'Back to store',
        picksize: 'Pick the size',
        added1: "You've added",
        added2: 'to the cart, do you want',
        added3: 'finalize your order?',
        from: 'From',
        unit: 'unit',
        oystermin: 'Minimum order',
        seemore: 'see more',
        selectqty: 'Select quantity',
        whatsyourreq: "WHAT'S IN YOUR ORDER:",
        pricestable: 'PRICES TABLE',
        finalize2: 'FINALIZE',
        choosepw: 'Choose password',
        unavailable: 'Temporarily unavailable',
        exportation: 'Wholesale',
        mastername: 'Manager name',
        institutional: 'Institutional Website',
        deliveryChooseStore: "Select a store to continue your order",
        location: "LOCATION",
        goBack: "Go back",
        homeDelivery: "Home Delivery",
        zipErrorMsg:
    "We're sorry, but we don't deliver in your location currently, you can always pick-up on our store",
    validate: "Validate",
    takeAway: "Take Away",
    chooseShop: "Choose Store",
    enterShop:"Choose takeaway",

    },
    pt:{
        about: "Sobre",
        services: "Serviços",
        menu: "Carta",
        profile: "Perfil",
        register: "Registar",
        choose: "Escolher",
        order: "Encomendar",
        follow: "Acompanhar",
        fresh: "Produtos Frescos",
        environment: "Amigo do Ambiente",
        delivery: "Entrega em Casa",
        phone : "Telemóvel",
        namesurname : "Nome",
        recoverpw : "Esqueci-me da password",
        recover : "Confirmar",
        repeatpw: "Repetir password",
        closedstore: "De momento a loja responsável por esta zona encontra-se em manutenção. Prometemos ser breves.",
        newpw : "Nova password",
        code: "O seu código de ativação",
        termstxt : "Li e aceito os ",
        termstxt2 : " e a ",
        terms: 'Termos e Condições',
        policy: 'Política de Privacidade',
        registration : "Registo",
        haveaccount : "Já tenho uma conta. ",
        gologin: 'Ir para o Log in',
        confirm : "Confirmar",
        sms : "IRÁ RECEBER UM SMS COM UM CÓDIGO DE ATIVAÇÃO DA SUA CONTA",
        smsconfirm : "Enviámos um código para o número",
        enter : "Entrar",
        address : "Morada",
        name : "Nome",
        zipcode : "Código-Postal",
        surname : "Apelido",
        message : "Mensagem",
        servicemessage: "Mensagem (inclua detalhes relevantes, como data pretendida, nº de pessoas, etc",
        zone : "Zona",
        door : "Porta",
        floor : "Andar",
        nif : "NIF",
        noorders : "Não tem encomendas ativas.",
        updated : "Atualizado!",
        hi : "Olá",
        hdtext : "Insira o seu código postal e verifique se se encontra nas nossas zonas de entrega.",
        tatext: "Escolha a loja onde pretende levantar a sua encomenda.",
        status : "Estado da encomenda",
        tracker0 : "Encomenda paga",
        tracker1 : "Encomenda em espera",
        tracker2 : "Encomenda em preparação",
        tracker3 : "Controlo de qualidade",
        tracker31 : "Encomenda pronta",
        tracker4 : "Encomenda a caminho",
        tracker5 : "Encomenda entregue",
        personalData : "Dados pessoais",
        billingData : "Dados de Faturação",
        deliveryaddr: "Moradas de Entrega",
        billingaddr : "Morada de Faturação",
        noorder: "Não tem informação para ver o estado da encomenda",
        feels : "Sinta-se em casa",
        cart : "Carrinho de compras",
        cartempty : "O carrinho está vazio",
        add : "Adicionar",
        interested: "Interessado em",
        agendar : "Agendar um serviço?",
        workwith : "Trabalhe connosco",
        kitchen : "Cozinha",
        city: 'Cidade',
        mastername: 'Nome do responsável',
        client : "Atendimento ao Cliente",
        client1 : "Atendimento",
        distribution : "Distribuição",
        kitchendesc : "Procuramos sushimen talentosos",
        clientdesc : "Procuramos quem tenha um sorriso na voz",
        distributiondesc : "Procuramos os estafetas mais simpáticos de Portugal",
        send : "Enviar",
        privacy : "Política de Privacidade",
        feedback : "Dê-nos a sua opinião",
        seeall: "Ver todos",
        apply: "Aplicar",
        finalize: "Finalizar pedido",
        validcode: "Código válido!",
        invalidcode: "Código inválido!",
        menus: "Menus",
        personalize: "Personalizar",
        options: "Opções",
        verify: "Verificar",
        nodelivery: "Lamentamos muito! Ainda não entrega no código postal indicado",
        nodelivery1: "? Para mais esclarecimentos por favor contacte-nos através do número 211625990",
        wrongformat: "Formato inválido xxxx-xxx",
        product: "Produto",
        quantity: "Quantidade",
        price: "Preço",
        continue: "Continuar",
        remove: "remover",
        prodstotal: "Total de produtos:",
        taxtext: "Gastos de envio estimados:",
        iva: "*IVA incluído",
        selectstore: "Selecionar loja",
        when: "Para quando deseja a sua encomenda?",
        today: "Hoje",
        tomorrow: "Amanhã",
        selectschedule: "Escolha a hora",
        totalprice: "Preço total",
        back: "Recuar",
        payment: "Como prefere pagar?",
        dinheiro: "Dinheiro",
        MB: "Multibanco",
        mbway: "MB Way",
        cc: "Cartão de crédito",
        finalize1: "Finalizar pedido",
        maxmoney: "Os nossos funcionários não têm troco para notas superiores a 20€",
        change: "Quanto troco vai necessitar?",
        cardnumber : "Número do cartão",
        cardholder : "Nome do titular",
        orderdone: "Encomenda realizada",
        orderdonetxt: "A sua encomenda foi feita com sucesso. Siga agora a sua encomenda",
        hiText: "Bem vindo",
        category: "Categorias",
        spec: "Características",
        all: "Todas",
        carddetails: "Preencha os detalhes do cartão",
        ordersuccessmbway: "A sua encomenda será processada assim que o pagamento seja efetuado na app MB WAY",
        error: "Erro!",
        history: "Histórico de Encomendas",
        nohistory: "Não tem encomendas feitas",
        singOrder: "Encomenda",
        repeat: "Repetir Encomenda",
        added: "Adicionado ao Carrinho!",
        minorder: "Para uma encomenda delivery sem pelo menos um menu combinado, o mínimo é 15€",
        error601: 'O Cartão de Crédito não foi aceite',
        error602: 'CVV ou marca do cartão inválidos',
        error603: 'O Cartão de Crédito não tem 3D secure ativado',
        alternativephone: 'Contacto alternativo',
        contact: 'Contacto',
        people: 'Para quantas pessoas?',
        quantityerror: 'Escolha pelo menos ',
        quantityerror1: ' no ',
        quantityerror2: 'º passo',
        desire: 'Deseja adicionar sobremesa?',
        mbwaypromo: 'O código promocional #campanhambway só será aplicado caso escolha o método de pagamento MB Way',
        birthday: 'Data nascimento (dd/mm/yyyy)',
        birthdayformat: 'Formato da data de nascimento inválido. Use dd/mm/yyyy',
        insertlogin: 'Insira os seus dados para continuar',
        registese: 'Registe-se',
        welcome: 'Bem vindo',
        noaccount: 'Não tem conta?',
        createaccount: 'Criar uma conta',
        recovertitle: "Recuperar password",
        wrongnum: 'O número não está correto?',
        goback: 'Voltar atrás',
        total: 'Total',
        tax : 'Taxa de entrega',
        mydata: 'Os menus dados',
        activeorders: 'Encomendas Ativas',
        orderhistory: 'Histórico de Encomendas',
        companyname: 'Nome da Empresa',
        number : 'Número',
        companytype: 'Tipo de Establecimento',
        restaurant: 'Restaurante',
        bar: 'Bar-Café',
        hotel: 'Hotel',
        other: 'Outro',
        other1: 'Entrega3',
        save: 'Guardar',
        account: 'Conta',
        home: 'Casa',
        home1: 'Entrega1',
        work: 'Trabalho',
        work1: 'Entrega2',
        makelog: 'Faça Login',
        yourprofile: 'O seu perfil',
        yourreq: 'O seu pedido',
        deliverydetails: 'Detalhes da Entrega',
        deliverydate: 'Data de Entrega',
        info1: 'Encomendas',
        info2: 'até às 17h00',
        info3: 'são processadas nesse dia, e entregues no dia seguinte',
        info4: 'após as 17h00',
        info5: 'são processadas no dia seguinte',
        info6: 'Encomendas processadas',
        info7: 'à 6ªf',
        info8: 'tem um custo adicional de 5€',
        selectday: 'Selecione o dia de entrega',
        selecthour: 'Hora prevista de entrega:',
        selectoneday: 'Selecione um dia',
        selectonehour: 'Selecione um horário',
        obs: 'Observações',
        promocode: 'Código Promocional',
        putpromo: 'Introduza o código promocional',
        paymentmethod: 'Método de pagamento',
        changefor: 'Troco para',
        mbwayphone: 'Nº telemóvel associado',
        offers: 'Ofertas',
        deltax: 'Taxa de Entrega',
        tdisc: 'Total com desconto',
        mintotal: 'O total mínimo é de 5€',
        cart1: 'Carrinho',
        start: 'Início',
        aboutus: 'Sobre nós',
        blog: 'Blog',
        faq: 'Perguntas Frequentes',
        contacts: 'Contactos',
        reseller: 'Sou dono de um restaurante',
        store: 'Loja',
        scheduletxt: 'As entregas realizam-se',
        scheduletxt1: 'entre as',
        scheduletxt2: 'do dia selecionado',
        moreprods: 'Deseja adicionar mais algum produto?',
        backstore: 'Voltar à loja',
        picksize: 'Escolha o tamanho',
        added1: 'Adicionou',
        added2: 'ao carrinho, deseja',
        added3: 'finalizar a compra?',
        from: 'Desde',
        unit: 'a unidade',
        oystermin: 'Ordem mínima',
        seemore: 'ver mais',
        selectqty: 'Selecione a quantidade',
        whatsyourreq: 'O QUE VEM COM O SEU PEDIDO:',
        pricestable: 'TABELA DE PREÇOS',
        finalize2: 'FINALIZAR',
        choosepw: 'Defina password',
        unavailable: 'Indisponível de momento',
        exportation: 'Exportação',
        institutional: 'Site Institucional',
        deliveryChooseStore: "Selecione uma loja para continuar o seu pedido",
        location: "LOCALIZAÇÃO",
        goBack: "Voltar",
        homeDelivery: "Entrega ao Domicílio",
        zipErrorMsg:
    "Lamentamos mas ainda não efectuamos entregas na sua Zona, pode sempre fazer uma encomenda take away",
        validate: "Validar",
        takeAway: "Take Away", 
        chooseShop: "Escolher Loja",
        enterShop:"Escolher takeaway",
    }
};
